import React from 'react'
import { FormSection } from 'redux-form'
import { equals, defaultTo, not } from 'ramda'
import { Divider, Button, Icon } from 'antd'
import ChangePasswordForm from './ChangePasswordForm'
import TwoFactorAuthentication from './TwoFactorAuthentication'
import { isEmptyOrNull } from '../../../../utils/helpers'

const SecurityAndLogin = (props) => {

  const { updateSecurityandLoginDetails, formValues } = props,
    { changePassword } = defaultTo({}, formValues),
    { newPassword, confirmPassword } = defaultTo({}, changePassword),
    formInavlid = isEmptyOrNull(newPassword) ? false : not(equals(newPassword, confirmPassword))

  const handleSubmit = event => {
    event.preventDefault()

    if(!formInavlid && updateSecurityandLoginDetails){
      updateSecurityandLoginDetails()
    }
  }

  return (
    <div>
      <div className="inner-wrapper">
        <div className="steps-content">
          <div className="steps-header">
            <h3>Security and Login</h3>
          </div>
          <form onSubmit={handleSubmit}>
            <FormSection name="changePassword">
              <Divider>Two Factor Authentication</Divider>
              <div className="form-section-div">
                <TwoFactorAuthentication
                  formValues={formValues}
                />
              </div>
              <Divider>Change Password</Divider>
              <div className='form-section-div'>
                <ChangePasswordForm />
              </div>
            </FormSection>
            <Button
              shape="round"
              className="success-btn content-submit-btn"
              htmlType="submit"
              disabled={formInavlid}
            >
              <Icon type="check" /> Save
            </Button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default SecurityAndLogin
